<template>
  <wrap-container>
    <form-validator>
      <section-label
        v-if="tipo === 'consulta'"
        value="Contactate con nosotros"
      />
      <!--INICIO BLOQUE EMPRESAS -->
      <wrap-container v-if="esEmpresas">
        <wrap-container class="grid-container grid-container--6-6">
          <number-input
            class="col1"
            label="CUIT Empresa *"
            v-model="model.cuitEmpresa"
            :disabled="paramsCash.cuitEmpresa != null"
            name="cuit-empresa"
            maxlength="11"
            minlength="11"
            :required="true"
          />
          <text-input
            class="col2"
            label="Razon Social *"
            v-model="model.razonSocial"
            :disabled="paramsCash.razonSocial != null"
            name="Razon Social"
            maxlength="100"
            :required="true"
          />
        </wrap-container>
        <wrap-container class="grid-container grid-container--6-6">
          <number-input
            class="col2"
            label="Codigo de empresa Net Cash"
            v-model="model.codigoEmpresa"
            :disabled="paramsCash.codigoEmpresa != null"
            name="Codigo de empresa NetCash"
            maxlength="10"
            :required="false"
          />
          <text-input
            class="col1"
            label="Usuario Net Cash"
            v-model="model.usuarioNetCash"
            :disabled="paramsCash.usuarioNetCash != null"
            name="Usuario Net Cash"
            maxlength="50"
            :required="false"
          />
        </wrap-container>
      </wrap-container>
      <!--FIN BLOQUE EMPRESAS -->
      <wrap-container class="grid-container grid-container--6-6">
        <text-input
          class="col1"
          label="Apellido *"
          hint="Ingresá tu apellido"
          v-model="model.apellido"
          :disabled="paramsCash.apellido != null"
          name="apellido"
          :maxlength="esEmpresas ? '50' : '1000'"
          :required="true"
        />
        <text-input
          class="col2"
          label="Nombre *"
          hint="Ingresá tu nombre"
          v-model="model.nombre"
          :disabled="paramsCash.nombre != null"
          name="nombre"
          :maxlength="esEmpresas ? '50' : '1000'"
          :required="true"
        />
      </wrap-container>
      <wrap-container
        v-if="tipo === 'consulta' || tipo === 'feedback' || tipo === 'denuncia'"
        class="grid-container grid-container--6-6"
      >
        <document-type class="col1" v-model="model.tipoDoc" :required="true" />
        <number-input
          class="col2"
          label="Número de documento *"
          hint="Ej: 28956372"
          v-model="model.numeroDoc"
          :disabled="paramsCash.numeroDoc != null"
          :required="true"
          maxlength="8"
        />
      </wrap-container>
      <email-field
        class="col1"
        label="Email *"
        v-model="model.email"
        :disabled="paramsCash.email != null"
        name="email"
        :required="true"
        :maxlength="esEmpresas ? '150' : '1000'"
      />
      <!-- INICIO BLOQUE EMPRESAS -->
      <wrap-container v-if="esEmpresas">
        <email-field
          v-if="paramsCash.email != null"
          class="col2"
          label="Confirmación Email *"
          v-model="model.email"
          :compare="model.email"
          :disabled="paramsCash.email != null"
          name="confirmacionEmail"
          :required="true"
          maxlength="150"
        />
        <email-field
          v-if="!paramsCash.email"
          class="col2"
          label="Confirmación Email *"
          v-model="model.confirmacionEmail"
          :compare="model.email"
          name="confirmacionEmail"
          :required="true"
          maxlength="150"
        />
      </wrap-container>
      <!--FIN BLOQUE EMPRESAS -->
      <wrap-container v-if="tipo === 'consulta' && esEmpresas">
        <section-label value="Teléfono de contacto" />
        <phone-number v-model="model.celular" :required="true" />
      </wrap-container>
      <!--INICIO BLOQUE EMPRESAS -->
      <wrap-container v-if="esEmpresas">
        <section-label value="Sobre tu consulta" />
        <wrap-container class="container">
          <span class="error motivos" v-if="errorMotivos">
            <img src="@/assets/img/1x/error_icon.png" :alt="error" />
            <span>
              Ocurrió un error al obtener los motivos de consulta. Intenta
              nuevamente en unos minutos</span
            >
          </span>
          <custom-select
            :required="true"
            :disabled="esSostenibilidad"
            v-model="model.ayuda"
            @input="resetFields"
            :selected-label="ayudaLabel"
            @update:selected-label="(label) => (ayudaLabel = label)"
            label="En que podemos ayudarte"
            :items="esEmpresas ? itemsAyudaEmpresas : itemsAyuda"
          />
        </wrap-container>

        <wrap-container class="container">
          <custom-select
            :required="true"
            :disabled="esSostenibilidad"
            v-model="model.tema"
            v-if="esEmpresas ? itemsTemaEmpresas.length : itemsTema.length"
            :selected-label="temaLabel"
            @update:selected-label="(label) => (temaLabel = label)"
            label="Tema"
            :items="esEmpresas ? itemsTemaEmpresas : itemsTema"
          />
        </wrap-container>

        <wrap-container class="container">
          <custom-select
            :required="true"
            :disabled="esSostenibilidad"
            v-model="model.subtema"
            v-if="
              esEmpresas ? itemsSubtemaEmpresas.length : itemsSubtema.length
            "
            :selected-label="subtemaLabel"
            @update:selected-label="(label) => (subtemaLabel = label)"
            label="Subtema"
            :items="esEmpresas ? itemsSubtemaEmpresas : itemsSubtema"
          />
        </wrap-container>

        <wrap-container class="container">
          <custom-select
            :required="true"
            :disabled="esSostenibilidad"
            v-model="model.motivo"
            v-if="esEmpresas ? itemsMotivoEmpresas.length : itemsMotivo.length"
            :selected-label="motivoLabel"
            @update:selected-label="(label) => (motivoLabel = label)"
            label="Motivo"
            :items="esEmpresas ? itemsMotivoEmpresas : itemsMotivo"
          />
        </wrap-container>
      </wrap-container>
      <!--FIN BLOQUE EMPRESAS -->
      <wrap-container v-if="!esEmpresas">
        <section-label value="Detalle" />
        <div id="mensajeAlert">
          <img
            src="@/assets/img/1x/0info_icon.png"
            height="23px"
            alt="Info icon"
          />
          <p>
            Nunca te vamos a pedir que nos compartas los datos de tus tarjetas,
            Clave Digital, Clave Token o Código SMS
          </p>
        </div>
        <details-input
          class="col1"
          label="Mensaje"
          hint="Ingresá tu mensaje en hasta 500 caracteres"
          v-model="model.mensaje"
          name="mensaje"
          maxlength="500"
          :required="true"
        />
      </wrap-container>
      <!--INICIO BLOQUE EMPRESAS -->
      <wrap-container v-if="esEmpresas">
        <section-label value="Detalle" />
        <details-input
          class="col1"
          label="Mensaje"
          hint="En caso de error, por favor indicar el mensaje textual, la fecha y la hora en la que se realizó la operación."
          v-model="model.mensaje"
          name="mensaje"
          maxlength="600"
          :required="true"
        />
      </wrap-container>
      <wrap-container v-if="esEmpresas && !esSostenibilidad">
        <FileUpload
          @fileChange="actualizarPropsArchivo"
          v-bind:accept="'.jpg,.png,.gif,.pdf,.doc,.docx,.xls,.xlsx,.txt'"
        />
        <br />
        <div
          id="archivosPermitidos"
          style="display: flex; align-items: flex-start"
        >
          <svg
            viewBox="0 0 260 260"
            preserveAspectRatio="xMidYMid meet"
            focusable="false"
            style="
              pointer-events: none;
              width: 1.23rem;
              height: 1.23rem;
              overflow: hidden;
              margin-right: 0.5rem;
              margin-bottom: 0;
            "
            aria-hidden="true"
          >
            <path
              d="M130 10a120 120 0 1 0 120 120A120 120 0 0 0 130 10Zm10 190-20-20v-70h20ZM130 90a15 15 0 1 1 15-15 15 15 0 0 1-15 15Z"
              fill="#004481"
            ></path>
          </svg>
          <span
            >El formato del archivo debe ser JPG, PNG, GIF, PDF, DOC, DOCX, XLS,
            XLSX y TXT con un máximo de 2MB</span
          >
        </div>
      </wrap-container>
      <!--FIN BLOQUE EMPRESAS -->
      <wrap-container v-if="esEmpresas">
        <p>
          <strong>Protección de datos personales</strong>
        </p>
        <p>
          Los datos personales que proporciones a través de este formulario
          serán tratados por Banco BBVA Argentina S.A. con la finalidad de
          gestionar tu solicitud de contacto, brindarte información y
          asesoramiento sobre los productos y servicios de BBVA y, cuando
          corresponda, enviarte comunicaciones comerciales y ofertas que puedan
          resultar de tu interés.
        </p>
        <p>
          La información podrá ser compartida con empresas del Grupo BBVA y con
          proveedores o prestadores de servicios que actúen por cuenta del
          Banco, bajo condiciones que garanticen la confidencialidad y seguridad
          de los datos, así como con autoridades regulatorias o judiciales
          cuando corresponda legalmente.
        </p>
        <p>
          Como titular de los datos, podés ejercer los derechos de acceso,
          rectificación, actualización y supresión previstos en la Ley N.º
          25.326 de Protección de Datos Personales, contactándote a
          dpo-arg@bbva.com o de forma presencial en cualquiera de nuestras
          sucursales.
        </p>
        <p>
          Asimismo, podés solicitar en cualquier momento el retiro o bloqueo,
          total o parcial, de tus datos respecto de comunicaciones con fines
          publicitarios.
        </p>
        <p>
          La Agencia de Acceso a la Información Pública (AAIP), en su carácter
          de órgano de control de la Ley N.º 25.326, tiene la atribución de
          atender las denuncias y reclamos que se interpongan con relación al
          incumplimiento de las normas sobre protección de datos personales.
        </p>
        <p>
          Para conocer más sobre cómo BBVA recopila, utiliza, comparte y protege
          tus datos personales, consultá nuestra Política de Privacidad y
          Protección de Datos Personales.
        </p>
      </wrap-container>
      <!--FIN BLOQUE EMPRESAS -->
      <span class="error" v-if="errorFormulario">
        <img src="@/assets/img/1x/error_icon.png" :alt="error" />
        <span> Ocurrió un error al enviar el formulario</span>
        <ul v-for="(item, index) in textoError" v-bind:key="index">
          <li>{{ item }}</li>
        </ul>
      </span>
      <wrap-container>
        <sales-button
          label="Aceptar y enviar"
          :input-style="{ padding: 0 }"
          @click="validarRecaptcha"
        />
      </wrap-container>
    </form-validator>
    <lottie-loader v-if="loading" />
    <wrap-container class="recaptcha">
      <vue-recaptcha
        ref="recaptcha"
        sitekey="6Lfp-yUUAAAAAFcXnw7yb4EhrGGz0zmF3SZhqViW"
        size="invisible"
        badge="inline"
        @verify="enviarForm"
      ></vue-recaptcha>
    </wrap-container>
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import LottieLoader from "@/components/core/LottieLoader";
import FormValidator from "@/components/core/FormValidator";
import TextInput from "@/components/core/TextInput";
import EmailField from "@/components/core/EmailField";
import PhoneNumber from "@/components/core/composite/PhoneNumber.vue";
import DetailsInput from "@/components/core/DetailsInput";
import SectionLabel from "@/components/core/SectionLabel";
import SalesButton from "@/components/core/SalesButton";
import NumberInput from "@/components/core/NumberInput";
import DocumentType from "@/components/core/composite/combos/DocumentType";
import { tiposDocumento } from "@/config/constants";
import VueRecaptcha from "vue-recaptcha";
import API from "../../../api";
import CustomSelect from "../../../components/core/custom/CustomSelect.vue";
import { getParameterByNameIgnoringNull } from "@/utils";
import FileUpload from "@/components/core/custom/FileUpload";

const COD_MOTIVO_CATE = "804";
const COD_SUBMOT01_CATE = "80420002";
const COD_SUBMOT02_CATE = "80420002100000";
const COMBOS_SOSTENIBILIDAD = {
  ayuda: {
    [COD_MOTIVO_CATE]: {
      label: "Consultas",
      tema: {
        [COD_SUBMOT01_CATE]: {
          label: "Sostenibilidad",
          subtema: {
            [COD_SUBMOT02_CATE]: {
              label: "Calculadora de huella de carbono",
            },
          },
        },
      },
    },
  },
};

export default {
  name: "FormularioContacto",
  props: {
    tipo: {
      type: String,
      default: "consulta",
    },
  },
  components: {
    WrapContainer,
    FormValidator,
    LottieLoader,
    TextInput,
    EmailField,
    PhoneNumber,
    SectionLabel,
    SalesButton,
    DetailsInput,
    DocumentType,
    NumberInput,
    VueRecaptcha,
    CustomSelect,
    FileUpload,
  },
  data() {
    return {
      textoError: ["Inténtelo nuevamente más tarde."],
      loading: false,
      errorFormulario: false,
      errorMotivos: false,
      fileName: "",
      fileBase64: "",
      esEmpresas: _BBVA_CAMP === "ofertaEmpresas",
      esSostenibilidad:
        _BBVA_CAMP === "ofertaEmpresas" && this.tieneParametroSostenibilidad(),
      resultadoSostenibilidad: this.obtenerResultadoSostenibilidad(),
      objetoCombos: { ayuda: {} },
      paramsCash: {
        apellido: getParameterByNameIgnoringNull("apellido"),
        nombre: getParameterByNameIgnoringNull("nombre"),
        numeroDoc: getParameterByNameIgnoringNull("dni"),
        email: getParameterByNameIgnoringNull("mail", null, true),
        cuitEmpresa: getParameterByNameIgnoringNull("cuit"),
        codigoEmpresa: getParameterByNameIgnoringNull("codEmp"),
        usuarioNetCash: getParameterByNameIgnoringNull("usuario"),
        razonSocial: getParameterByNameIgnoringNull("razSoc"),
        fromNetCash: getParameterByNameIgnoringNull("fromNetCash"),
      },
      model: {
        apellido: "",
        nombre: "",
        tipoDoc: tiposDocumento[0].value,
        numeroDoc: "",
        email: "",
        celular: {
          area: "",
          numero: "",
        },
        cuitEmpresa: "",
        codigoEmpresa: "",
        usuarioNetCash: "",
        razonSocial: "",
        ayuda: null,
        tema: null,
        subtema: null,
        motivo: null,
        mensaje: "",
      },
      ayudaLabel: "",
      temaLabel: "",
      subtemaLabel: "",
      motivoLabel: "",
    };
  },
  computed: {
    itemsAyudaEmpresas() {
      return Object.keys(this.objetoCombos.ayuda).map((item) => {
        return {
          label: this.objetoCombos.ayuda[item].label,
          value: item,
        };
      });
    },
    itemsAyuda() {
      return Object.keys(this.config.combos.ayuda).map((item) => {
        return {
          label: this.config.combos.ayuda[item].label,
          value: item,
        };
      });
    },
    itemsTemaEmpresas() {
      if (this.model.ayuda) {
        return Object.keys(this.objetoCombos.ayuda[this.model.ayuda].tema).map(
          (item) => {
            return {
              label: this.objetoCombos.ayuda[this.model.ayuda].tema[item].label,
              value: item,
            };
          }
        );
      }
      return [];
    },
    itemsTema() {
      if (this.model.ayuda) {
        return Object.keys(this.config.combos.ayuda[this.model.ayuda].tema).map(
          (item) => {
            return {
              label:
                this.config.combos.ayuda[this.model.ayuda].tema[item].label,
              value: item,
            };
          }
        );
      }
      return [];
    },
    itemsSubtemaEmpresas() {
      if (this.model.tema) {
        return Object.keys(
          this.objetoCombos.ayuda[this.model.ayuda].tema[this.model.tema]
            .subtema
        ).map((item) => {
          return {
            label:
              this.objetoCombos.ayuda[this.model.ayuda].tema[this.model.tema]
                .subtema[item].label,
            value: item,
          };
        });
      }
      return [];
    },
    itemsSubtema() {
      if (this.model.tema) {
        return Object.keys(
          this.config.combos.ayuda[this.model.ayuda].tema[this.model.tema]
            .subtema
        ).map((item) => {
          return {
            label:
              this.config.combos.ayuda[this.model.ayuda].tema[this.model.tema]
                .subtema[item].label,
            value: item,
          };
        });
      }
      return [];
    },
    itemsMotivoEmpresas() {
      if (
        this.model.subtema &&
        this.objetoCombos.ayuda[this.model.ayuda].tema[this.model.tema].subtema[
          this.model.subtema
        ] &&
        this.objetoCombos.ayuda[this.model.ayuda].tema[this.model.tema].subtema[
          this.model.subtema
        ].motivo
      ) {
        return Object.keys(
          this.objetoCombos.ayuda[this.model.ayuda].tema[this.model.tema]
            .subtema[this.model.subtema].motivo
        ).map((item) => {
          return {
            label:
              this.objetoCombos.ayuda[this.model.ayuda].tema[this.model.tema]
                .subtema[this.model.subtema].motivo[item],
            value: item,
          };
        });
      }
      return [];
    },
    itemsMotivo() {
      if (
        this.model.subtema &&
        this.config.combos.ayuda[this.model.ayuda].tema[this.model.tema]
          .subtema[this.model.subtema] &&
        this.config.combos.ayuda[this.model.ayuda].tema[this.model.tema]
          .subtema[this.model.subtema].motivo
      ) {
        return Object.keys(
          this.config.combos.ayuda[this.model.ayuda].tema[this.model.tema]
            .subtema[this.model.subtema].motivo
        ).map((item) => {
          return {
            label:
              this.config.combos.ayuda[this.model.ayuda].tema[this.model.tema]
                .subtema[this.model.subtema].motivo[item],
            value: item,
          };
        });
      }
      return [];
    },
  },
  methods: {
    validarRecaptcha() {
      this.$refs.recaptcha.reset();
      this.loading = true;
      this.$refs.recaptcha.execute();
    },
    resetFields() {
      this.model.tema = null;
      this.model.subtema = null;
      this.model.motivo = null;
    },
    tieneParametroSostenibilidad() {
      return getParameterByNameIgnoringNull("SOSTENIBILIDAD") !== null;
    },
    obtenerResultadoSostenibilidad() {
      return getParameterByNameIgnoringNull("SOSTENIBILIDAD");
    },
    cargarCombosSostenibilidadFallback() {
      this.objetoCombos = COMBOS_SOSTENIBILIDAD;
      this.esperarRender(this.seleccionarSostenibilidad);
    },
    esperarRender(callback) {
      this.$nextTick(() => setTimeout(callback, 50));
    },
    seleccionarSostenibilidad() {
      const ayuda = this.objetoCombos.ayuda[COD_MOTIVO_CATE];
      const tema = ayuda && ayuda.tema && ayuda.tema[COD_SUBMOT01_CATE];
      const subtema = tema && tema.subtema && tema.subtema[COD_SUBMOT02_CATE];
      if (!ayuda || !tema || !subtema) return;

      this.model.ayuda = COD_MOTIVO_CATE;
      this.ayudaLabel = ayuda.label;

      this.esperarRender(() =>
        this.seleccionarTemaSostenibilidad(tema, subtema)
      );
    },
    seleccionarTemaSostenibilidad(tema, subtema) {
      this.model.tema = COD_SUBMOT01_CATE;
      this.temaLabel = tema.label;
      this.esperarRender(() => this.seleccionarSubtemaSostenibilidad(subtema));
    },
    seleccionarSubtemaSostenibilidad(subtema) {
      this.model.subtema = COD_SUBMOT02_CATE;
      this.subtemaLabel = subtema.label;
    },
    enviarForm(token) {
      const { data } = this.$route.meta;
      const payload = {
        //se envia tipo de consulta vacio para que no falle en SF
        tipoConsulta: " ",
        datos: { ...this.model },
        c: _BBVA_CAMP,
        token,
      };

      if (this.esSostenibilidad) {
        payload.datos.mensaje = `Calculado CO2: ${this.resultadoSostenibilidad} - Comentario Cliente: ${this.model.mensaje}`;
      }

      if (_BBVA_CAMP === "ofertaLibroDeQuejas") {
        payload.producto = "Libro de quejas";
        payload.motivo = "Libro de quejas";
      } else {
        payload.producto = data ? data[0] : "";
        payload.motivo = data ? data[1] : "";
      }

      if (_BBVA_CAMP === "ofertaEmpresas") {
        payload.datos.ayudaLabel = this.ayudaLabel;
        payload.datos.temaLabel = this.temaLabel;
        payload.datos.subtemaLabel = this.subtemaLabel;
        payload.datos.motivoLabel = this.motivoLabel;
        payload.datos.enviadoDesde = this.esSostenibilidad
          ? "SOSTENIBILIDAD"
          : this.paramsCash.fromNetCash
          ? "Privado"
          : "Público";
        payload.datos.nombreAdjunto = this.fileName;
        payload.datos.archivoAdjunto = this.fileBase64;
      }

      const endPoint =
        _BBVA_CAMP === "ofertaEmpresas"
          ? "formularioConsultaEmpresas/consulta"
          : "formularioConsulta/consulta";
      API.request({ endPoint, payload })
        .then((response) => {
          this.loading = false;
          if (endPoint == "formularioConsultaEmpresas/consulta") {
            //CASO EMPRESAS
            if (String(response.data) === "true") {
              this.$router.push({
                name: "gracias",
                params: {
                  tipoGracias: this.tipo,
                  email: this.model.email,
                  nombre: this.model.nombre,
                },
              });
            } else {
              window.scrollTo(0, document.body.scrollHeight - 1000);
              //Se muestra mensaje de error
              this.errorFormulario = true;
            }
          } else {
            //CASO INDIVIDUOS
            if (response.data.caseId) {
              //Se recibió CaseId - Formulario llego a Salesforce correctamente
              this.$router.push({
                name: "gracias",
                params: {
                  tipoGracias: this.tipo,
                  email: this.model.email,
                  nombre: this.model.nombre,
                },
              });
            } else {
              //No se recibió CaseId - Falló la consulta
              window.scrollTo(0, document.body.scrollHeight - 1000);
              //si se recibe un mensaje de error se utiliza para la alerta
              if (response.data.message) {
                //Se sacan los corchetes y se hace un split de los mensajes de error
                this.textoError = response.data.message
                  .replace("[", "")
                  .replace("]", "")
                  .split(",");
              }

              //Se muestra mensaje de error
              this.errorFormulario = true;
            }
          }
        })
        .catch(() => {
          this.loading = false;
          window.scrollTo(0, document.body.scrollHeight - 1000);
          //Se muestra mensaje de error
          this.errorFormulario = true;
        });
    },
    actualizarPropsArchivo(fileData) {
      this.fileName = fileData.fileName;
      this.fileBase64 = fileData.fileBase64;
    },
  },
  created() {
    (this.model.apellido = this.paramsCash.apellido),
      (this.model.nombre = this.paramsCash.nombre),
      (this.model.numeroDoc = this.paramsCash.numeroDoc),
      (this.model.email = this.paramsCash.email),
      (this.model.cuitEmpresa = this.paramsCash.cuitEmpresa),
      (this.model.codigoEmpresa = this.paramsCash.codigoEmpresa),
      (this.model.usuarioNetCash = this.paramsCash.usuarioNetCash),
      (this.model.razonSocial = this.paramsCash.razonSocial),
      (this.model.fromNetCash = this.paramsCash.fromNetCash);

    if (_BBVA_CAMP === "ofertaEmpresas") {
      if (this.esSostenibilidad) {
        this.cargarCombosSostenibilidadFallback();
        return;
      }

      API.getRequest("formularioConsultaEmpresas/obtenerMotivosEngage")
        .then((response) => {
          this.loading = false;
          if (response.data.status === "OK") {
            this.objetoCombos = JSON.parse(response.data.data);
          } else {
            window.scrollTo(0, document.body.scrollHeight - 1500);
            this.errorMotivos = true;
          }
        })
        .catch(() => {
          this.loading = false;
          window.scrollTo(0, document.body.scrollHeight - 1500);
          this.errorMotivos = true;
        });
    }
  },
};
</script>
<style scoped>
#mensajeAlert {
  background-color: #d5ecff;
  padding: 10px;
  line-height: 24px;
  display: flex;
  margin-bottom: 10px;
  font-family: BentonSansBBVA-Book, Helvetica, Arial, sans-serif;
  font-size: 15px;
}

#mensajeAlert img {
  margin: 1px 16px 5px 0px;
}

#mensajeAlert p {
  margin: 0px;
}

#archivosPermitidos {
  font-family: BentonSansBBVA-Light, Helvetica, Arial, sans-serif;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
}

span.error {
  background: #fcdfdf;
  margin: 8px 8px 20px 0px;
  padding: 12px;
  display: block;
}

span.error.motivos {
  margin: 0 0 0 0;
  font-size: 12px;
  background: inherit;
}

.recaptcha {
  margin-top: 32px;
  opacity: 0.3;
}

#mensajeAlert {
  background-color: #d5ecff;
  padding: 10px;
  line-height: 24px;
  display: flex;
  margin-bottom: 10px;
  font-family: BentonSansBBVA-Book, Helvetica, Arial, sans-serif;
  font-size: 15px;
}

#mensajeAlert img {
  margin: 1px 16px 5px 0px;
}

#mensajeAlert p {
  margin: 0px;
}
</style>
